import { LocaleKeys } from '../../../../locale/translation-types'

export enum PersonalityEnum {
  ENERGETIC = 'ENERGETIC',
  SOCIABLE = 'SOCIABLE',
  ARTISTIC = 'ARTISTIC',
  STUDIOUS = 'STUDIOUS',
  ATHLETIC = 'ATHLETIC',
  TALKATIVE = 'TALKATIVE',
  SHY = 'SHY',
  INDEPENDENT = 'INDEPENDENT'
}

export const personalityEnumMapping: Record<PersonalityEnum, LocaleKeys> = {
  [PersonalityEnum.ENERGETIC]: 'personality.enum.ENERGETIC',
  [PersonalityEnum.SOCIABLE]: 'personality.enum.SOCIABLE',
  [PersonalityEnum.ARTISTIC]: 'personality.enum.ARTISTIC',
  [PersonalityEnum.STUDIOUS]: 'personality.enum.STUDIOUS',
  [PersonalityEnum.ATHLETIC]: 'personality.enum.ATHLETIC',
  [PersonalityEnum.SHY]: 'personality.enum.SHY',
  [PersonalityEnum.TALKATIVE]: 'personality.enum.TALKATIVE',
  [PersonalityEnum.INDEPENDENT]: 'personality.enum.INDEPENDENT'
}
